import React, { Component } from 'react';
import PropTypes from 'prop-types';
import hljs from 'highlight.js';
import classNames from 'classnames';

import languages from '../../constants/languages';
import { getVNodes } from '../../utils/vdom';
import PreviewChild from './PreviewChild';

hljs.configure({
  languages,
});

export default class PreviewCode extends Component {
  static propTypes = {
    node: PropTypes.object,
    codeKey: PropTypes.string,
    lang: PropTypes.string,
  };

  state = {
    showCode: false,
    code: '',
  };

  componentWillMount() {
    if (!this.state.showCode) {
      this.renderCode(this.props);
    }
  }

  componentWillReceiveProps(nextProps) {
    this.renderCode(nextProps);
  }

  renderCode = (props) => {
    this.getFenceChild(props).then((fenceChild) => {
      this.setState({
        showCode: true,
        code: fenceChild,
      });
    });
  };

  getFenceChild = (props) => {
    const { node, lang, codeKey: key } = props;
    return new Promise((resolve) => {
      setImmediate(() => {
        const { value } = node;
        let code = {
          value: '',
        };
        try {
          code = hljs.highlight(lang, value);
        } catch (e) {
          code = hljs.highlightAuto(value);
        }
        const codeClass = classNames({
          hljs: true,
          [`${code.language}`]: !!code.language,
        });
        const VNodes = getVNodes(code.value);
        const fenceChild = (
          <code
            key={key}
            className={codeClass}
          >
            {VNodes.map((vNode, index) => {
              return (
                <PreviewChild
                  key={`code-${index}`}
                  node={vNode}
                  parentType={'code'}
                  parentIndex={`code-${index}`}
                />
              );
            })}
            {/* {getReactElements(code.value)} */}
          </code>
        );
        resolve(fenceChild);
      });
    });
  };

  render() {
    const { node } = this.props;
    const { showCode, code } = this.state;
    return showCode ? code : (
      <code className="hljs">
        <PreviewChild
          node={node}
          parentType={'code'}
        />
      </code>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/PreviewVDOM/PreviewCode.js